import * as React from "react"
import enUS from "./locale/locale_en.json";
import esES from "./locale/locale_es_ES.json"
import frFR from "./locale/locale_fr_FR.json"



export interface LanguageProviderProps {
    locale?: 'en-US' | 'es-ES' | 'fr-FR' ,
    children?: React.JSX.Element
}

const LocaleProviderContext = React.createContext(enUS)
LocaleProviderContext.displayName = "LocaleProvider"

export const LocaleProvider: React.FC<LanguageProviderProps> = (props) => {

    const {children , locale} = props

    const localeMapper = React.useCallback(() => {
        switch (locale) {
            case "en-US":
                return enUS
            case "fr-FR":
                return frFR
            case "es-ES":
                return esES
            default:
                return enUS
        }

    }, [locale])


    const localeToDisplay = React.useMemo(() => {
        return localeMapper()
    }, [localeMapper])

    return (
        <LocaleProviderContext.Provider value={localeToDisplay}>
                {children}
        </LocaleProviderContext.Provider>
    )
}


LocaleProviderContext.displayName = "LocaleProvider"
export const useLocaleProvider = () => {
    return React.useContext(LocaleProviderContext)
}